import PropTypes from 'prop-types'
import React from 'react'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import { redirectToWishlistPage } from 'components/cart/utils'

const CartWishlistIcon = ({ closeCart, updateShowLogin }) => (
  <div>
    <Icon
      alt="wishlist-icon"
      src={ICONS.wishlist}
      className="svg-close"
      size={ICON_SIZE.medium}
      onClick={() => redirectToWishlistPage(closeCart, updateShowLogin)}
      cy="wishlist_cart"
    />
  </div>
)

CartWishlistIcon.propTypes = {
  closeCart: PropTypes.func.isRequired,
  updateShowLogin: PropTypes.func.isRequired,
}

export default CartWishlistIcon
